/**
 * Details — what the plugin is called, what it says about itself, and where it
 * runs. The kind is shown, not changed here: a save keeps it as it is.
 */

import { useToast } from '../../components/common';
import { Field, WhereItRuns } from './bits';
import { errorsAt, kindLabel } from './manifest';

export default function DetailsStep({ draft, setDraft, disabled, errors = [] }) {
  const toast = useToast();
  const set = (patch) => setDraft({ ...draft, ...patch });
  const at = (k) => errorsAt(errors, k).map((e) => e.message);

  const discovered = (found) => {
    const have = new Set((draft.tools || []).map((t) => t.tool_id));
    const fresh = found.filter((t) => !have.has(t.tool_id))
      .map(({ input_schema: _schema, ...t }) => t);
    if (fresh.length) {
      set({ tools: [...(draft.tools || []), ...fresh] });
      toast.success(`Added ${fresh.length} tool${fresh.length === 1 ? '' : 's'} to Tools.`);
    }
  };

  return (
    <div className="pw__step">
      <section className="pw__sec">
        <h2 className="pw__h">About it</h2>
        <div className="pw__fields">
          <Field label="Name" errors={at('name')}>
            <input className="pw__in" value={draft.name} disabled={disabled}
                   onChange={(e) => set({ name: e.target.value })} />
          </Field>
          <Field label="Description" errors={at('description')}>
            <textarea className="pw__in" rows={3} value={draft.description} disabled={disabled}
                      onChange={(e) => set({ description: e.target.value })} />
          </Field>
          <Field label="How to use it">
            <textarea className="pw__in" rows={2} value={draft.usage_guide} disabled={disabled}
                      onChange={(e) => set({ usage_guide: e.target.value })} />
          </Field>
        </div>
      </section>
      <section className="pw__sec">
        <h2 className="pw__h">Where it runs · {kindLabel(draft.execution_type)}</h2>
        <WhereItRuns draft={draft} set={set} disabled={disabled} errors={errors} onDiscovered={discovered} />
      </section>
    </div>
  );
}
